import React, { useRef } from 'react'
import TemplatePreviewBubble from '../TemplatePreviewBubble'
import { aplicarVariaveis } from '../../libs/scheduledMessages'
import { numero } from '../../libs/disparos'

// Passo "Mensagem" na conexão por QR Code: texto livre com campos da lista
// ({{nome}}, {{telefone}} e as colunas da planilha) e um arquivo opcional por
// link público. A prévia mostra como chega para o primeiro da lista.

const LIMITE = 4096

function nomeDoArquivo(url) {
  try {
    const caminho = new URL(url).pathname
    return decodeURIComponent(caminho.split('/').filter(Boolean).pop() || '') || url
  } catch (e) {
    return url
  }
}

export default function MensagemDeTexto({ texto, onTexto, arquivo = '', onArquivo, colunas = [], exemplo,
  variaveis, marcarVariavel, renderizarPrevia, mostrarArquivo = true, rotuloVariaveis = 'Inserir campo da lista:',
  rotuloPrevia, erroId, placeholder = 'Olá {{nome}}, sua fatura vence amanhã.' }) {
  const campo = useRef(null)
  const disponiveis = variaveis || ['nome', 'telefone', ...colunas.filter((c) => c !== 'nome' && c !== 'telefone')]
  const quem = exemplo?.name || exemplo?.phone

  // Põe o {{campo}} onde o cursor está (ou no fim) e devolve o foco ao texto.
  const inserir = (coluna) => {
    const el = campo.current
    const marca = marcarVariavel ? marcarVariavel(coluna) : `{{${coluna}}}`
    const inicio = el ? el.selectionStart : texto.length
    const fim = el ? el.selectionEnd : texto.length
    onTexto(`${texto.slice(0, inicio)}${marca}${texto.slice(fim)}`)
    requestAnimationFrame(() => {
      if (!el) return
      el.focus()
      el.setSelectionRange(inicio + marca.length, inicio + marca.length)
    })
  }

  const previa = renderizarPrevia ? renderizarPrevia(texto, exemplo) : aplicarVariaveis(texto, exemplo)

  return (
    <div className="dp-dois">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 }}>
        <textarea
          ref={campo}
          className="dp-texto"
          aria-label="Mensagem"
          aria-invalid={!!erroId}
          aria-describedby={erroId}
          placeholder={placeholder}
          value={texto}
          onChange={(e) => onTexto(e.target.value)}
        />
        <div className="dp-inserir">
          {/* Sem campos para inserir (ex.: o texto livre de teste, que não tem lista), fica só o contador. */}
          {disponiveis.length > 0 && <span>{rotuloVariaveis}</span>}
          {disponiveis.map((c) => (
            <button key={c} type="button" onClick={() => inserir(c)}>{c}</button>
          ))}
          <span className="dp-contador" style={{ marginLeft: 'auto' }}>
            {numero(texto.length)} / {numero(LIMITE)}
          </span>
        </div>
        {mostrarArquivo && <div className="dp-bloco">
          <h4>Arquivo (opcional)</h4>
          <p className="dp-sub">Link público https de uma imagem, PDF, áudio ou vídeo.</p>
          <input
            className="dp-campo"
            aria-label="Link do arquivo"
            placeholder="https://"
            inputMode="url"
            value={arquivo}
            onChange={(e) => onArquivo(e.target.value)}
          />
        </div>}
      </div>

      <div className="dp-telefone">
        {texto.trim() ? (
          <>
            <span className="dp-quem">{rotuloPrevia || (quem ? `Como chega para ${quem}` : 'Como chega para o cliente')}</span>
            <TemplatePreviewBubble template={{ components: [{ type: 'BODY', text: previa }] }} values={[]} />
            {arquivo.trim() && <span className="dp-quem">📎 {nomeDoArquivo(arquivo.trim())}</span>}
          </>
        ) : (
          <span className="dp-telefone-vazio">Escreva a mensagem para ver como ela chega no WhatsApp do cliente.</span>
        )}
      </div>
    </div>
  )
}

export { nomeDoArquivo }
